import styled, { css } from 'styled-components';
import { media } from 'settings/style';

interface HeroImgProps {
  overlay?: boolean;
  filter?: string;
  img: string;
  /** Shown at md breakpoint and below (typically mobile). Defaults to `img` when omitted. */
  mobileImg?: string;
  parallex?: boolean;
  height?: string;
}

// prettier-ignore
const HeroImg = styled.div<HeroImgProps>`
  ${({ img, mobileImg, parallex, height = "70vh" }) => css`
    background-image: url(${img});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    width: 100%;
    height: ${height};
    position: relative;
    display: flex;
    justify-content: center;

    ${mobileImg &&
    media.md`
      background-image: url(${mobileImg});
    `}
    
    ${parallex &&
    css`
      background-attachment: fixed;
    `}

    ${media.md`
      background-attachment: scroll;
      height: 40vh;
    `}

  `}
`;

export default HeroImg;
